import { autoinject } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { MepYearOverYearComparison } from "../../tabs/mep-year-over-year-comparison/mep-year-over-year-comparison";
import {CustomerDetailsModel} from "../../../../../../models/customers/customer.models";
import {RightShipDialogServiceConstants} from "../../../../../../constants/basics/rightship-dialog.constants";

@autoinject
export class PrintMepYearOverYearDialog {

    model: MepYearOverYearComparison;
    sectionVesselCalls?: boolean = true;
    sectionDistinctVesselCount?: boolean = true;
    sectionTugJobs?: boolean = true;
    sectionEmissionsYearOverYearComparison?: boolean = true;
    customerDetails: CustomerDetailsModel;

    constructor(private dialogClientService: DialogClientService) {}

    activate(model: MepYearOverYearComparison){
        this.model = model;

        //Vessel statistics
        this.model.mainStatisticsViewModels.forEach(x=> {
            if(x.statisticsByYear.length <= 0) {
                if(x.title == "Vessel Calls"){
                    this.sectionVesselCalls = null;
                } 
                else if (x.title == "Distinct Vessel Count") {
                    this.sectionDistinctVesselCount = null;
                }
                else if (x.title == "Tugboat Jobs") {
                    this.sectionTugJobs = null;
                }
            }
        });

        this.customerDetails = CustomerDetailsModel.getCustomerDetailModelFromRSUser(window["rightshipUser"]);
    }

    attached() {
        if (this.model.lineChartViewModel.criteriaPollutantsItems.length > 0) {
            this.model.lineChartViewModel.pollutantsEmissionsChartViewModel.initChart("chartpollutantsdivprint");
        }

        if (this.model.lineChartViewModel.ghgEmissionsItems.length > 0) {
            this.model.lineChartViewModel.ghgEmissionsChartViewModel.initChart("chartghgdivprint");
        }
    }

    close() {
        this.dialogClientService.hide();
    }

    printDocument() {
        //If the current user is a customer with a trial account
        if(this.customerDetails?.isMepTrial) {
            this.dialogClientService.show(RightShipDialogServiceConstants.URLs.TrialVersionDialog, {customerId: this.customerDetails.customerId, title: 'Print Report'});
        }
        else {
            $(".document-port-year-over-year").printThis({
                importCSS: true,
                importStyle: true,
                loadCSS: "/styles/core.min.css",
                canvas: true
            });
        }
    }

    showVesselStatstics(name: string) {
        if(name == "Vessel Calls" && this.sectionVesselCalls){
            return true;
        } 
        else if (name == "Distinct Vessel Count" && this.sectionDistinctVesselCount) {
            return true;
        }
        else if (name == "Tugboat Jobs" && this.sectionTugJobs) {
            return true;
        }
        return false;
    }

    showChart(id: number): boolean {
        return this.model.lineChartViewModel.emissionsChartViewModels[id] == this.model.lineChartViewModel.ghgEmissionsChartViewModel 
            ? this.model.lineChartViewModel.ghgEmissionsItems.length > 0
            : this.model.lineChartViewModel.criteriaPollutantsItems.length > 0;
    }
}